export default "__VITE_ASSET__Ch48Ycjx__"